import { ReactNode } from 'react';

interface ScrollingContainerProps {
  children?: ReactNode;
  className?: string;
  height?: number | string;
}

// Generic container with scrollable content.  By default the container height
// and width will match their parent container but can be overriden by passing
// in a className.  Additionally in cases where you need more dynamic control
// over the height you can pass in a height prop which will override any
// styles passed in via the className prop.
export default function ScrollingContainer({
  children,
  className,
  height,
}: ScrollingContainerProps): JSX.Element {
  return (
    <div className={className} data-testid="scrolling-container-outer-container" style={{ height }}>
      <div className="inner-container">{children}</div>
      <style jsx>{`
        .inner-container {
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          height: 100%;
        }
      `}</style>
    </div>
  );
}
